<template>
  <v-container class="mb-10" fluid>
    <v-btn
      v-show="go_top"
      v-scroll="onScroll"
      fab
      dark
      fixed
      bottom
      rigth
      color="red"
      @click="toTop"
    >
      <v-icon> mdi-chevron-up</v-icon>
    </v-btn>
    <v-card elevation="0" color="transparent">
      <v-row justify="center" align="center">
        <v-col cols="12" sm="6">
          <v-card class="mx-auto" elevation="1" height="300" outlined>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  {{ $t("labellisation.custom.name") }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ $t("labellisation.custom.label") }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset />
            <v-row justify="center" align="center" dense no-gutters>
              <v-col cols="12" sm="12">
                <v-sheet class="pa-4 chip-group">
                  <v-chip-group
                    v-model="selection"
                    column
                    :multiple="cust_del ? true : false"
                    :class="
                      cust_del
                        ? 'red--text text--accent-4'
                        : 'primary--text text--accent-4'
                    "
                    @change="get_values(custom_elements[selection])"
                  >
                    <v-chip
                      v-for="(custum, index) in custom_elements"
                      :key="index"
                      filter
                      :filter-icon="cust_del ? '' : 'mdi-check'"
                      outlined
                    >
                      <v-icon v-if="cust_del" left size="17" class="mr-1">
                        {{
                          selection && selection.includes(index)
                            ? "mdi-checkbox-marked-outline"
                            : "mdi-checkbox-blank-outline"
                        }}
                      </v-icon>
                      {{ custum }}
                    </v-chip>
                    <v-chip
                      v-if="
                        new_custom && !this.custom_elements.includes(new_custom)
                      "
                      :disabled="new_custom ? true : false"
                      class="ma-1 primary--text text--accent-4"
                    >
                      <v-icon left size="19"> mdi-eye-plus </v-icon>
                      {{ new_custom }}
                    </v-chip>
                  </v-chip-group>
                </v-sheet>
              </v-col>
              <v-col class="clos" sm="12">
                <v-row class="pt-3" dense no-gutters>
                  <v-col cols="4" sm="6">
                    <v-combobox
                      v-if="add_new"
                      v-model="new_custom"
                      outlined
                      dense
                      :items="custom_elements"
                      clearable
                      class="ma-2 ml-4"
                      label="Labels"
                      chips
                      small-chips
                      deletable-chips
                      @change="check_new_custom(new_custom)"
                    />
                  </v-col>
                  <div style="position: absolute; right: 1%; bottom: 5%">
                    <v-btn
                      v-if="!cust_del"
                      v-show="custom_elements.length"
                      class="ma-1 elevation-0"
                      outlined
                      depressed
                      color="error"
                      @click="delete_custom()"
                    >
                      {{ $t("labellisation.custom.delete") }}
                    </v-btn>
                    <v-btn
                      v-else
                      v-show="custom_elements.length"
                      class="ma-1 elevation-0"
                      outlined
                      depressed
                      dark
                      color="error"
                      @click="delete_confirmation()"
                    >
                      {{ $t("labellisation.custom.done") }}
                    </v-btn>
                    <v-btn
                      dark
                      outlined
                      class="ma-1 elevation-0"
                      color="primary"
                      @click="init_add()"
                    >
                      {{ $t("labellisation.custom.add_new") }}
                    </v-btn>
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card class="mx-auto" elevation="1" height="300" outlined>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  {{ $t("labellisation.tags.name") }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ $t("labellisation.tags.label") }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <div
                v-if="selectedTag && $store.state.selector.selectedIndexes"
                class="pt-5"
              >
                <v-list-item-subtitle class="mr-2 black--text text--accent-4">
                  <v-icon size="16" class="mb-1" color="primary">
                    mdi-hanger
                  </v-icon>
                  Tag : {{ selectedTag }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="mr-2 black--text text--accent-4">
                  <v-icon size="16" class="mb-1" color="primary">
                    mdi-checkbox-marked-circle
                  </v-icon>
                  {{ $t("labellisation.tags.prod_num") }} :
                  {{
                    $store.state.selector.selectedIndexes
                      ? $store.state.selector.selectedIndexes.length
                      : 0
                  }}
                </v-list-item-subtitle>
              </div>
            </v-list-item>
            <v-divider inset />
            <v-row dense no-gutters>
              <v-col
                v-if="custom_elements_tags.length || new_tag.length"
                cols="12"
                sm="12"
              >
                <v-sheet class="pa-4 chip-group">
                  <v-chip
                    v-for="tag in custom_elements_tags"
                    :key="tag"
                    class="ma-1"
                    filter
                    outlined
                    :color="itemTags(tag) ? 'primary' : ''"
                    :text-color="itemTags(tag) ? 'primary' : ''"
                    @click="get_chips(tag)"
                  >
                    <v-avatar v-if="itemTags(tag)" left>
                      <v-icon size="19"> mdi-wrench </v-icon>
                    </v-avatar>
                    <v-icon
                      v-if="!itemTags(tag)"
                      left
                      size="22"
                      color="#847f7f"
                    >
                      mdi-hanger
                    </v-icon>
                    {{ tag }}
                  </v-chip>
                  <v-chip
                    v-for="chip in new_tag"
                    :key="chip"
                    class="ma-1"
                    text-color="white"
                    color="black"
                  >
                    <v-icon left size="19"> mdi-checkbox-marked-circle </v-icon>
                    {{ chip }}
                  </v-chip>
                </v-sheet>
              </v-col>
              <v-col v-else cols="12" sm="12">
                <v-sheet class="pa-4">
                  <v-chip
                    v-for="tag in empty_tags"
                    :key="tag"
                    disabled
                    class="ma-1"
                  >
                    <v-icon left size="22" color="#847f7f"> mdi-hanger </v-icon>
                    {{ tag }}
                  </v-chip>
                </v-sheet>
              </v-col>
              <v-col class="clos" sm="12">
                <v-row class="pt-3" dense no-gutters>
                  <v-col cols="6" sm="6">
                    <v-combobox
                      v-show="show_add_tags"
                      v-model="new_tag"
                      multiple
                      append-icon=""
                      outlined
                      dense
                      class="ma-2 inp"
                      clearable
                      label="Tags"
                      chips
                      small-chips
                      deletable-chips
                      @change="input_tags(new_tag)"
                    />
                  </v-col>
                  <div style="position: absolute; right: 1%; bottom: 5%">
                    <v-btn
                      v-show="selectedValue"
                      depressed
                      dark
                      outlined
                      class="ma-1 elevation-0"
                      color="primary"
                      @click="add_tag_click()"
                    >
                      {{ $t("labellisation.tags.add_new") }}
                    </v-btn>
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "SelectItems",
  data: () => ({
    custom_elements: [],
    custom_elements_tags: [],
    empty_tags: ["Tag 1...", "Tag 2...", "Tag 3...", "Tag 4...", "..."],
    selectedIndexes: [],
    check_icon: false,
    new_tag: [],
    selectedValue: null,
    selectedTag: null,
    show_add_tags: false,
    go_top: false,
    selection: [],
    new_custom: "",
    add_new: false,
    cust_del: false,
    cust_delet_prods: [],
    len: 0,
    temp_tag: "",
  }),
  computed: {
    products: {
      get: function () {
        const product = this.$store.state.product.products;
        this.set_custom_elements();
        return product;
      },
    },
  },
  destroyed() {
    this.CloseSelector();
  },
  mounted() {
    Object.values(this.products).forEach((ele) => {
      const elem = ele.custom;
      const custom_keys = Object.keys(elem);
      this.custom_keys_check(custom_keys);
      /// /console.log('mounted',custom_keys);
    });
  },
  methods: {
    set_custom_elements() {
      this.custom_elements = this.$store.state.product.customs;
    },
    init_add() {
      this.add_new = true;
      this.selection = undefined;
      this.custom_elements_tags = [];
      this.selectedValue = "";
      this.CloseSelector();
      this.show_add_tags = false;
      this.cust_del = false;
      this.selection = "";
      this.cust_delet_prods = [];
    },
    delete_custom() {
      this.new_custom = "";
      this.cust_del = !this.cust_del;
      this.selectedValue = "";
      this.custom_elements_tags = [];
      this.selection = "";
      this.CloseSelector();
      this.add_new = "";
    },
    delete_confirmation() {
      if (this.selection && this.selection.length) {
        this.$store
          .dispatch("confirmer/ask", {
            title: this.$t("show_box.title"),
            body: this.$t("show_box.agree"),
          })
          .then((confirmation) => {
            if (confirmation) {
              this.done_delete_custom();
            } else {
              this.cancel();
            }
          });
      } else {
        this.$store.dispatch("setSnackbar", {
          text: "No label selected ",
          color: "error",
          timeout: 1000,
        });
        this.cust_del = false;
        this.selection = "";
        this.cust_delet_prods = [];
      }
    },
    done_delete_custom() {
      const prods_ids = [];
      const prods_cust = [];
      const temp = [];
      if (this.selection.length) {
        for (let i = 0; i < this.selection.length; i++) {
          const element = this.selection[i];
          Object.values(this.products).filter((p) => {
            if (Object.keys(p.custom).includes(this.custom_elements[element])) {
              delete p.custom[this.custom_elements[element]];
              prods_ids.push(p.product_id);
              prods_cust.push(p.custom);
            }
          });
          temp.push(this.custom_elements[element]);
        }
        this.custom_elements = this.custom_elements.filter(
          (x) => temp.indexOf(x) === -1
        );
        this.$store.state.product.customs = this.custom_elements;
        // console.log(prods_ids, prods_cust);
        const obj = {
          ids: prods_ids,
          customs: prods_cust,
        };
        this.$store.dispatch("setLoader", {
          showing: true,
          text: "Removing (label/lables)",
        });
        this.$store.dispatch("UPDATE_PRD", obj).then((r) => {
          this.$store.dispatch("setLoader", {
            showing: false,
            text: "Removing (label/lables)",
          });
          this.$store.dispatch("setSnackbar", {
            text: "Removing label successfully !",
            color: "success",
            timeout: 1000,
          });
        });
      }
      this.cust_del = false;
      this.selection = "";
      this.cust_delet_prods = [];
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.go_top = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    openSelector() {
      this.len = 0;
      this.$store
        .dispatch("selector/select", {
          active: true,
          multiple: true,
          selectedIndexes: this.selectedIndexes,
          selected_value: this.selectedValue,
          products: this.all,
        })
        .then((prod) => {
          prod.filter((p) => {
            if (p.selected) {
              this.len = this.len + 1;
            }
          });
          this.all = prod;
          this.confirmDestruction();
        });
    },
    custom_keys_check(val) {
      val.forEach((ele) => {
        if (!this.custom_elements.includes(ele)) this.custom_elements.push(ele);
      });
    },
    CloseSelector() {
      this.$store.dispatch("selector/select", {
        active: false,
      });
    },
    itemTags(val) {
      if (val === this.selectedTag) return true;
      return false;
    },
    confirmDestruction() {
      this.$store
        .dispatch("confirmer/ask", {
          title: this.$t("show_box.title"),
          body: this.$t("show_box.agree"),
        })
        .then((confirmation) => {
          if (confirmation) {
            this.temp_tag = this.selectedTag;
            this.add_custom();
          } else {
            this.cancel();
          }
        });
    },
    cancel() {
      this.new_tag = [];
      this.selectedTag = null;
    },
    add_custom() {
      if (this.new_tag.length) {
        Object.values(this.all).forEach((element) => {
          if (
            !Object.keys(element.prod_data.custom).includes(this.selectedValue)
          ) {
            element.prod_data.custom[this.selectedValue] = this.new_tag;
          } else {
            // console.log("new_tag", this.new_tag, this.selectedValue, this.all);
            for (let i = 0; i < this.new_tag.length; i++) {
              const tag = this.new_tag[i];
              element.prod_data.custom[this.selectedValue].push(tag);
            }
          }
        });
      } else {
        // console.log(this.selectedTag, this.selectedValue, this.all);
        Object.values(this.all).forEach((element) => {
          if (
            !Object.keys(element.prod_data.custom).includes(this.selectedValue)
          ) {
            element.prod_data.custom[this.selectedValue] = [];
            if (
              !element.prod_data.custom[this.selectedValue].includes(
                this.selectedTag
              )
            ) {
              element.prod_data.custom[this.selectedValue].push(
                this.selectedTag
              );
            }
            // console.log("click one2",element.prod_data.custom[this.selectedValue]);
          } else {
            if (
              !element.prod_data.custom[this.selectedValue].includes(
                this.selectedTag
              )
            ) {
              element.prod_data.custom[this.selectedValue].push(
                this.selectedTag
              );
            } else {
              if (element.selected == false) {
                var removeIndex = element.prod_data.custom[
                  this.selectedValue
                ].indexOf(this.selectedTag);
                // console.log("delete",element.prod_data.product_id,removeIndex );
                element.prod_data.custom[this.selectedValue].splice(
                  removeIndex,
                  1
                );
              }
            }
          }
        });
      }

      Object.values(this.all).forEach((element) => {
        this.$store.dispatch("setLoader", {
          showing: true,
          text: "Saving the products",
        });
        this.$store
          .dispatch("UPDATE_PRODUCTS", element.prod_data)
          .then((r) => {
            this.$store.dispatch("setLoader", {
              showing: false,
              text: "Saving the products",
            });
          })
          .catch((err) => {
            err.response.status == 404;
            console.log("error in update tags");
          });
      });
      this.$store.dispatch("setSnackbar", {
        text: "Changes added successfully !",
        color: "success",
        timeout: 1000,
      });
      if (!this.custom_elements.includes(this.selectedValue)) {
        this.custom_elements.push(this.selectedValue);
      }
      if (this.new_tag.length && !this.temp_tag) {
        this.custom_elements_tags = this.custom_elements_tags.concat(
          this.new_tag
        );
      }
      this.selectedIndexes = [];
      this.all = [];
      this.select = [];
      if (this.len == 0) {
        const idx = this.custom_elements_tags.indexOf(this.temp_tag);
        this.custom_elements_tags.splice(idx, 1);
      }
      this.selectedTag = null;
      this.new_tag = [];
      this.new_custom = "";
      this.show_add_tags = false;
    },
    check_new_custom(val) {
      if (this.custom_elements.includes(val)) {
        this.selection = this.custom_elements.indexOf(val);
        this.get_values(val);
        this.new_custom = "";
      } else {
        this.get_values(val);
      }
    },
    get_values(val) {
      if (!this.cust_del) {
        this.selectedValue = val;
        this.show_add_tags = false;
        this.custom_elements_tags = [];
        this.new_tag = [];
        this.selectedTag = null;
        this.CloseSelector();
        const item = this.selectedValue;
        Object.values(this.products).forEach((ele) => {
          if (ele.custom[item]) {
            const custom_obj = ele.custom[item];
            this.ckeck_exist_values(custom_obj);
          }
        });
        if (!this.selectedValue) {
          this.show_add_tags = false;
          this.selectedIndexes = [];
          this.CloseSelector();
        }
        this.add_new = false;
        /// /console.log('change', this.selectedValue)
      }
    },
    ckeck_exist_values(val) {
      val.forEach((ele) => {
        if (!this.custom_elements_tags.includes(ele)) {
          this.custom_elements_tags.push(ele);
        }
      });
    },
    get_chips(tag) {
      this.selectedTag = tag;
      this.selectedIndexes = [];
      this.all = [];
      this.new_tag = [];
      this.show_add_tags = false;
      const arr = [];
      Object.values(this.products).forEach((ele) => {
        if (ele.custom[this.selectedValue]) {
          if (ele.custom[this.selectedValue].includes(tag)) {
            arr.push(ele.product_id);
            this.all.push({ prod_data: ele, selected: true });
          }
        }
      });
      this.selectedIndexes = this.getUnique(arr);
      /// /console.log(this.selectedIndexes, this.all);
      // console.log(this.all);
      this.openSelector();
    },
    getUnique(array) {
      // remove duplicate elements in array
      var uniqueArray = [];

      // Loop through array values
      for (var value of array) {
        if (uniqueArray.indexOf(value) === -1) {
          uniqueArray.push(value);
        }
      }
      return uniqueArray;
    },
    add_tag_click() {
      this.selectedTag = null;
      this.selectedIndexes = [];
      this.all = [];
      this.new_tag = [];
      this.show_add_tags = true;
      this.CloseSelector();
    },
    input_tags(tags) {
      if (!this.new_tag.length) {
        this.selectedIndexes = [];
        this.CloseSelector();
      }
      if (tags.length == 1) {
        this.openSelector();
      }

      for (let index = 0; index < tags.length; index++) {
        const element = tags[index];
        if (this.custom_elements_tags.includes(tags[index])) {
          this.$store.dispatch("setSnackbar", {
            text: `Error tag " ${tags[index]} " already exists in  " ${this.selectedValue} "`,
            color: "error",
            timeout: 1000,
          });
          this.new_tag.splice(index, 1);
        }
      }
    },
  },
};
</script>

<style scoped>
.modifiable:hover {
  border: 4px solid #ccc;
  cursor: pointer;
}
.active {
  cursor: pointer;
  display: block;
  opacity: 0.69;
}
input {
  display: none;
}
.check {
  color: red;
  position: absolute;
  font-size: 80px;
  padding: 7px;
}
.clear-prod {
  margin-left: 20px;
}
.btns {
  text-align: center;
  width: 100%;
}
.header {
  user-select: none;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.6);
}
.subheader {
  user-select: none;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
  margin: -10px 49px 15px;
}
.chip-group {
  height: 134px;
  overflow: hidden scroll;
  width: 100%;
}
.chip-group::-webkit-scrollbar {
  width: 7px;
  height: 15%; /* width of the entire scrollbar */
}
.chip-group::-webkit-scrollbar-track {
  background: #80808070;
  border-radius: 19px; /* color of the tracking area */
}
.chip-group::-webkit-scrollbar-thumb {
  background-color: #1a4dcd; /* color of the scroll thumb */
  border-radius: 19px; /* roundness of the scroll thumb */
  border: 1px solid grey; /* creates padding around scroll thumb */
}
.inp {
  position: absolute;
  bottom: -6%;
  left: 0;
  width: 50%;
}
</style>
